const START_PATH = "/integrations/hibob/start";
const LABEL = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

const parseBaseDomains = (value) =>
	(typeof value === "string" ? value : "")
		.split(",")
		.map((base) => base.trim().toLowerCase())
		.filter(Boolean);

// The browser is only sent to the start page on the current tenant's own API
// host, <subDomain>.api.<base>, for one of our base domains.
export const isValidStartUrl = (
	startUrl,
	subDomain,
	baseDomains = process.env.REACT_APP_HIBOB_TENANT_BASE_DOMAINS,
) => {
	const tenant = typeof subDomain === "string" ? subDomain.trim().toLowerCase() : "";
	const bases = parseBaseDomains(baseDomains);
	if (!LABEL.test(tenant) || !bases.length || typeof startUrl !== "string") {
		return false;
	}
	try {
		const url = new URL(startUrl);
		return (
			url.protocol === "https:" &&
			url.port === "" &&
			url.username === "" &&
			url.password === "" &&
			url.pathname === START_PATH &&
			bases.some((base) => url.hostname === `${tenant}.api.${base}`)
		);
	} catch (err) {
		return false;
	}
};
